/**
 *
 * DayChart
 *
 */

import { Component } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import { DATE_FORMATS, parse } from "utils/Date";
import Calendar from "./Calendar";
import Header, { HEADER_HEIGHT } from "./Header";

const DEFAULT_WIDTH = "10rem";
const DEFAULT_HEIGHT = "20rem";

class DayChart extends Component {
  static HEADER_HEIGHT = HEADER_HEIGHT;

  static propTypes = {
    times: PropTypes.object.isRequired,
    timeBlocks: PropTypes.array,
    highlights: PropTypes.array,
    dayparts: PropTypes.array,
    height: PropTypes.string,
    width: PropTypes.string,
    showHeader: PropTypes.bool,
  };

  static defaultProps = {
    timeBlocks: [],
    highlights: [],
    dayparts: [],
    showHeader: true,
    height: DEFAULT_HEIGHT,
    width: DEFAULT_WIDTH,
  };

  normalizeTimes(obj) {
    let startTime = null;
    if (typeof obj.planned_date_time_from === "object") {
      startTime = obj.planned_date_time_from.clone();
    } else {
      startTime = parse(obj.planned_date_time_from, DATE_FORMATS.BUMBAL);
    }

    let endTime = null;
    if (typeof obj.planned_date_time_to === "object") {
      endTime = obj.planned_date_time_to.clone();
    } else {
      endTime = parse(obj.planned_date_time_to, DATE_FORMATS.BUMBAL);
    }

    const startHours = startTime.hours();
    const startMinutes = startTime.minutes() / 60;

    const endHours = endTime.hours();
    const endMinutes = endTime.minutes() / 60;

    return {
      ...obj,
      startTime,
      endTime,
      startHours,
      startMinutes,
      start: startHours + startMinutes,
      endHours,
      endMinutes,
      end: endHours + endMinutes,
    };
  }

  render() {
    const bounds = this.normalizeTimes(this.props.times);
    const timeBlocks = this.props.timeBlocks.map(this.normalizeTimes);
    const highlights = this.props.highlights.map(this.normalizeTimes);
    const dayparts = this.props.dayparts.map(this.normalizeTimes);
    let calendarHeight = this.props.height;
    if (this.props.showHeader) {
      calendarHeight = `calc(${this.props.height} - ${HEADER_HEIGHT}px)`;
    }

    return (
      <Wrapper height={this.props.height} width={this.props.width}>
        {this.props.showHeader && (
          <Header date={this.props.times.planned_date_time_from} />
        )}
        <Calendar
          height={calendarHeight}
          width={this.props.width}
          bounds={bounds}
          highlights={highlights}
          dayparts={dayparts}
          timeBlocks={timeBlocks}
        />
      </Wrapper>
    );
  }
}

export default DayChart;

const Wrapper = styled.div`
  position: relative;
  height: ${({ height }) => height};
  width: ${({ width }) => width};
`;
